'use client';

import { HomePageItem, HomePageItemType } from '@/models/HomePage';
import { PriceData } from '@/models/Product';
import dynamic from 'next/dynamic';
import BannerlistWithBanner from './BannerlistWithBanner';
import BannerlistWithCategoryList from './BannerlistWithCategoryList';
import BannerlistWithProduct from './BannerlistWithProduct';

const ProductListSection = dynamic(() => import('./ProductListSection'));

export default function HomepageItem({
  item,
  index,
  isFirstItem,
  pricesData,
}: {
  item: HomePageItem;
  index: number;
  isFirstItem: boolean;
  pricesData: PriceData | null;
}) {
  switch (item.type) {
    case HomePageItemType.BANNERLIST_BANNER:
      return (
        <BannerlistWithBanner
          banner={item.banner}
          banners={item.banners}
          dir="ltr"
          key={index}
          isPriority={isFirstItem}
        />
      );
    case HomePageItemType.BANNER_BANNERLIST:
      return (
        <BannerlistWithBanner
          banner={item.banner}
          banners={item.banners}
          dir="rtl"
          key={index}
          isPriority={isFirstItem}
        />
      );
    case HomePageItemType.BANNERLIST_PRODUCT:
      return (
        <BannerlistWithProduct
          banners={item.banners}
          product={item.product}
          dir="ltr"
          key={index}
          isPriority={isFirstItem}
        />
      );
    case HomePageItemType.PRODUCT_BANNERLIST:
      return (
        <BannerlistWithProduct
          banners={item.banners}
          product={item.product}
          dir="rtl"
          key={index}
          isPriority={isFirstItem}
        />
      );
    case HomePageItemType.CATEGORY:
      return (
        <ProductListSection
          products={item.products}
          category={
            item.category ||
            (item.categories?.[0]
              ? {
                  id: item.categories[0].id,
                  title: item.categories[0].title,
                  imageUrl: item.categories[0].iconUrl,
                  url: item.categories[0].url,
                }
              : undefined)
          }
          title={item.title ?? ''}
          url={item.url ?? ''}
          showMore={true}
          key={index}
          showTitle={item.showCategoryTitle === 1}
          enableSwiper={false}
          preventPriceFetch={true}
          fetchedPricesData={pricesData}
        />
      );
    case HomePageItemType.BANNERLIST_CATEGORYLIST:
      return (
        <BannerlistWithCategoryList
          banners={item.banners}
          categories={item.categories}
          categoriesTitle={item.categoriesTitle || ''}
          dir="ltr"
          key={index}
          isPriority={isFirstItem}
        />
      );
    case HomePageItemType.CATEGORYLIST_BANNERLIST:
      return (
        <BannerlistWithCategoryList
          banners={item.banners}
          categories={item.categories}
          categoriesTitle={item.categoriesTitle || ''}
          dir="rtl"
          key={index}
          isPriority={isFirstItem}
        />
      );
    case HomePageItemType.BANNER_UNDER_CONTENT:
      return null;
    default:
      return null;
  }
}
